import { useSelectedCompany } from "~/shared/store/company/hooks/useSelectedCompany";
import { OrdersTable } from "../components/orders.table";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useServiceProviderStats } from "~/shared/store/stats/hooks/useServiceProviderStats";

export default function OrdersPage() {
  const { selectedCompanyId } = useSelectedCompany();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { unassignedJobCount } = useServiceProviderStats();

  if (!selectedCompanyId) return null;

  // Get order ID for highlighting from URL parameters
  const highlightOrderId = searchParams.get("highlightOrder");

  // Handler to reset highlight when clicking on a row. Which row is selected is
  // the table's own business — it tracks that internally.
  const handleRowClick = () => {
    // Reset highlight by removing parameter from URL
    if (highlightOrderId) {
      navigate(`/${selectedCompanyId}/orders`);
    }
  };

  return (
    <OrdersTable
      serviceProviderId={String(selectedCompanyId)}
      onRowClick={handleRowClick}
      highlightOrderId={highlightOrderId}
      unassignedJobCount={unassignedJobCount}
    />
  );
}
